import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";

//Limitless imports
import { NavigationItem, DestructiveOkCancelDialog, OkCancelDialog } from "@limitless/portal";
const EntityActionDialog = ({
  onOkClick,
  entityType,
  icon,
  actionType,
  isDestructive
}) => {
  const [overlayVisible, setOverlayVisibile] = React.useState(false);
  const sentenceCase = val => {
    return val.toLowerCase().split(" ").map(word => {
      return word.replace(word[0], word[0].toUpperCase());
    }).join(" ");
  };
  const titleText = sentenceCase(`${actionType} ${entityType}`);
  const Dialog = isDestructive ? DestructiveOkCancelDialog : OkCancelDialog;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationItem, {
    id: `${actionType}${sentenceCase(entityType)}Button`,
    text: titleText,
    icon: icon,
    link: "",
    selected: false,
    onClickHandle: () => setOverlayVisibile(true)
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: overlayVisible,
    title: titleText,
    okLabel: "Confirm",
    okId: "confirmEntityAction",
    onOKClick: () => {
      onOkClick();
      setOverlayVisibile(false);
    },
    onCancelClick: () => {
      setOverlayVisibile(false);
    }
  }, /*#__PURE__*/React.createElement(Typography, null, `Are you sure you wish to ${actionType} this ${entityType}?`)));
};
export default EntityActionDialog;
EntityActionDialog.propTypes = {
  onOkClick: PropTypes.func.isRequired,
  entityType: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  actionType: PropTypes.string.isRequired,
  isDestructive: PropTypes.bool
};
EntityActionDialog.defaultProps = {
  isDestructive: true
};